import script from "./previews.vue?vue&type=script&setup=true&lang=ts"
export * from "./previews.vue?vue&type=script&setup=true&lang=ts"

import "./previews.vue?vue&type=style&index=0&id=5cded563&scoped=true&lang=scss"

import exportComponent from "D:\\全部项目\\funeral-and-interment\\publicnumber\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cded563"]])

export default __exports__